<div class="surface-section px-4 py-3 md:py-8 md:px-6 lg:px-8">
  <div class="grid">

    <div class="col-12 block md:hidden bg-no-repeat bg-right-bottom"> <!--  style="background-image: url('assets/images/blocks/contact/contact-1.png')" -->
      <div class="text-900 text-xl font-medium mb-4" i18n>Get in Touch with the CircleSquare Team!</div>
      <div class="text-700 line-height-3 mb-4" i18n>Have questions, suggestions, or looking to join? We're here to serve you the answers.<br>Drop us a message and we'll rally back to you as soon as we can!</div>
      <div class="text-700 line-height-3 mb-4" i18n>Please note that <span class="font-bold">we are only the software provider, not the club or event organizer</span>. If you have any questions about a specific club or event, please contact them directly.</div>
      <!--<a class="inline-flex align-items-center text-blue-600 font-bold no-underline cursor-pointer">
        <span class="mr-3">View Address on Google Maps</span>
        <i class="pi pi-arrow-right"></i>
      </a>-->
      <ul class="list-none p-0 m-0 text-700 mb-5">
        <li class="flex align-items-center">
          <i class="pi pi-inbox mr-2"></i>
          <a class="text-primary" href="mailto:contact@circlesquare.app">contact&#64;circlesquare.app</a>
        </li>
      </ul>
    </div>

    <div class="col-12 md:col-6">

      <div class="p-fluid pr-0 md:pr-6">
        <div class="mb-4" *ngIf="showSuccess">
          <p-message severity="success" text="Your message has been sent!" i18n-text></p-message>
        </div>
        <div class="mb-4" *ngIf="showError">
          <p-message severity="error" text="There was an error sending your message. Please try again." i18n-text></p-message>
          <app-request-id class="block mt-2" [requestId]="errorReference"></app-request-id>
        </div>
        <form [formGroup]="contactForm" (ngSubmit)="onSubmit()">
          <div class="field">
            <label for="name" class="font-medium">Name</label>
            <input id="name" formControlName="name" type="text" pInputText>
            <app-form-error formControlName="name"></app-form-error>
          </div>
          <div class="field">
            <label for="email" class="font-medium">Email *</label>
            <input id="email" formControlName="email" type="text" pInputText>
            <app-form-error formControlName="email"></app-form-error>
          </div>
          <div class="field">
            <label for="phone" class="font-medium" i18n>Phone</label>
            <input id="phone" formControlName="phone" type="text" pInputText>
            <app-form-error formControlName="phone"></app-form-error>
          </div>
          <div class="field">
            <label for="publicId" class="font-medium flex align-items-center gap-2">
              CS ID
              <i class="pi pi-info-circle text-primary cursor-pointer"
                 [pTooltip]="csIdTooltip"
                 tooltipPosition="right"
                 style="font-size: 0.9rem"></i>
            </label>
            <input id="publicId" formControlName="publicId" type="text" pInputText>
          </div>
          <div class="field">
            <label for="subject" class="font-medium" i18n>Subject *</label>
            <input id="subject" formControlName="subject" type="text" pInputText>
            <app-form-error formControlName="subject"></app-form-error>
          </div>
          <div class="field">
            <label for="message" class="font-medium" i18n>Message *</label>
            <textarea id="message" formControlName="message" pInputTextarea rows="6" [autoResize]="true"></textarea>
            <app-form-error formControlName="message"></app-form-error>
          </div>
          <p-button pRipple label="Send Message" i18n-label icon="pi pi-send" class="w-auto" type="submit" [loading]="isSubmitting" [disabled]="!contactForm.valid"></p-button>
        </form>
      </div>
    </div>


    <div class="hidden md:block col-6 bg-no-repeat bg-right-bottom"> <!--  style="background-image: url('assets/images/blocks/contact/contact-1.png')" -->
      <div class="text-900 text-2xl font-medium mb-6" i18n>Get in Touch with the CircleSquare Team!</div>
      <div class="text-700 line-height-3 mb-3" i18n>Have questions, suggestions, or looking to join? We're here to serve you the answers.<br>Drop us a message and we'll rally back to you as soon as we can!</div>
      <div class="text-700 line-height-3 mb-6" i18n>Please note that we are only the software provider, not the club or event organizer. If you have any questions about a specific club or event, please contact them directly.</div>
      <!--<a class="inline-flex align-items-center text-blue-600 font-bold no-underline cursor-pointer">
        <span class="mr-3">View Address on Google Maps</span>
        <i class="pi pi-arrow-right"></i>
      </a>-->
      <ul class="list-none p-0 m-0 mt-6 text-700">
        <li class="flex align-items-center">
          <i class="pi pi-inbox mr-2"></i>
          <a class="text-primary" href="mailto:contact@circlesquare.app">contact&#64;circlesquare.app</a>
        </li>
      </ul>
    </div>
  </div>
</div>